"use client";
import { useRef, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { GetList } from "../../../hook/getList.tsx";
import CustomerItems from "./customerItems.tsx";
import React from "react";
import EmptyComponent from "../../../component/EmptyComponent/index.tsx";
import { useSelector } from "react-redux";
import { authSelect } from "../../../store/slice/auth.slice.tsx";
import Pagination from "../../../component/Pagination/index.tsx";

interface PageChangeEvent {
  selected: number;
}

const Customer = () => {
  const searchRef = useRef<HTMLButtonElement>(null);
  const [searchValue, setSearchValue] = useState("");
  const [committedSearch, setCommittedSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);
  const [page, setPage] = useState(1);
  const { userInfo } = useSelector(authSelect);
  const isStaff = userInfo?.role === "STAFF";

  const handlePageChange = ({ selected }: PageChangeEvent) => {
    console.log("selected ===== ", selected);
    loadMore(selected + 1);
    setPage(selected + 1);
  };
  const digitsOnly = (s: string) => /^\d+$/.test(s);
  const normalizePhone = (raw: string) => {
    const value = (raw || "").trim();
    if (!value) return value;
    const first = value.charAt(0);
    const second = value.charAt(1);
    if (first + second === "84") {
      return value;
    }
    if (first === "0") {
      return `${84}${value.toString().replace("0", "")}`;
    }
    return `${84}${value}`;
  };
  const isValidStaffPhone = (raw: string) => {
    const v = (raw || "").trim();
    if (!v) return false;
    if (v.startsWith("0")) return v.length === 10 && digitsOnly(v);
    if (v.startsWith("84")) return digitsOnly(v) && v.length === 11;
    return false;
  };

  const { data, loadMore, loading } = GetList<any>({
    url: "users/getListUser",
    params: { limit: 20, search: committedSearch, page: +page },
    dependencies: committedSearch,
  });
  const renderUser = (item: any, index: number) => {
    return <CustomerItems item={item} key={index} index={index} />;
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      if (isStaff) {
        if (!isValidStaffPhone(searchValue)) return;
        setHasSearched(true);
        setCommittedSearch(normalizePhone(searchValue).trim());
      } else {
        setHasSearched(true);
        setCommittedSearch(searchValue.trim());
      }
    }
  };

  const list = Array.isArray(data) ? data : data?.data?.results || [];
  const totalCount = Array.isArray(data) ? 0 : data?.count || 0;

  return (
    <div className="px-10">
      <div className="flex justify-center">
        <div
          className="
        flex 
        items-center 
        border-[1.5px] 
        w-[50%]
        rounded-lg
        pl-2
        border-[pink]
        "
        >
          <input
            className="flex w-full px-2 py-2 outline-none "
            placeholder="Tìm kiếm người dùng (nhập số điện thoại)"
            onChange={(e) => {
              setSearchValue(e.target.value);
              setHasSearched(false);
            }}
            onKeyDown={handleKeyPress}
          />
          <button
            onClick={() => {
              if (isStaff) {
                if (!isValidStaffPhone(searchValue)) return;
                setHasSearched(true);
                setCommittedSearch(normalizePhone(searchValue).trim());
              } else {
                setHasSearched(true);
                setCommittedSearch(searchValue.trim());
              }
            }}
            ref={searchRef}
            className="bg-[pink] px-3 h-full rounded-tr-lg rounded-br-lg"
          >
            <AiOutlineSearch size={26} />
          </button>
        </div>
      </div>

      <div className="mt-4 max-w-6xl mx-auto w-full px-2">
        {isStaff && !hasSearched ? null : (
          (list?.length > 0 && !loading) ? (
            list.map(renderUser)
          ) : (
            <EmptyComponent loading={loading} />
          )
        )}
      </div>
      
     {/* <div>
        {data?.data?.results?.length > 0 && !loading ? (
          data?.data?.results?.map(renderUser)
        ) : (
          <EmptyComponent loading={loading} />
        )}
      </div> */}

      {!isStaff && (
        <Pagination
          pageCount={Math.ceil(totalCount / 20)}
          onPageChange={handlePageChange}
          currentPage={page}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
        />
      )}
    </div>
  );
};

export default Customer;
